import { Search } from "@common/_constants";
import { Routing } from "@common/_constants/";
import { buildUrl, ErrorService, format } from "@common/_services";
import { refetch } from "@common/_services/refetch";
import { CandidateSearchOptions } from ".";

export const ReferralService = {
    declineJob,
    getActivities,
    getActivitiesSummary,
    getReferral,
    link,
    refer,
    search,
    update,
    updateApplication,
    validate,
};

function refer(jobCandidate) {
    const url = Routing.Api.Pro.Referrals.UPDATE;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(jobCandidate),
    };
    return refetch(url, settings).then(unwrapResult);
}

function validate(validationRequest){
    const url = Routing.Api.Pro.Referrals.VALIDATION_REQUEST;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(validationRequest)
    };
    return refetch(url, settings).then(unwrapResult);
}

function getReferral(
    jobCandidateId: number,
    abortSignal: AbortSignal,
    userId?: number,
    jobId?: number
) {
    const url = jobCandidateId
        ? format(Routing.Api.Pro.Referrals.DETAILS, { id: jobCandidateId })
        : format(Routing.Api.Pro.Referrals.DETAILS_BY_USER_AND_JOB, {
            userId,
            jobId,
        });
    const settings: RequestInit = {
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function search(options: CandidateSearchOptions, abortSignal: AbortSignal) {
    const url = Routing.Api.Pro.Referrals.SEARCH;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}
function declineJob(jobCandidateId, notes, rejectedReason) {
    const options = {
        job_candidate_rejected_reason: rejectedReason,
        job_candidate_status: Search.JobCandidateStatus.REJECTED,
        notes,
    };

    const url = format(Routing.Api.Pro.Referrals.UPDATE_STATUS, {
        id: jobCandidateId,
    });

    const settings: RequestInit = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
    };

    return refetch(url, settings).then(unwrapResult);
}

function link(job_id, user_id) {
    const options = { job_id, user_id };
    const url = Routing.Api.Pro.Referrals.LINK;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
    };
    return refetch(url, settings).then(unwrapResult);
}

function update(jobCandidate) {
    const url = `${Routing.Api.Pro.Referrals.UPDATE}/${jobCandidate.job_candidate_id}`;
    const settings: RequestInit = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(jobCandidate),
    };
    return refetch(url, settings).then(unwrapResult);
}

function updateApplication(jobCandidate) {
    const url = `${Routing.Api.Pro.Applications.UPDATE}/${jobCandidate.job_candidate_id}`;
    const settings = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(jobCandidate)
    };
    return refetch(url, settings).then(unwrapResult);
}
function getActivities(options, job_candidate_id, abortSignal: AbortSignal) {
    const url = format(Routing.Api.Pro.Referrals.ACTIVITIES, {
        id: job_candidate_id,
    });
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function getActivitiesSummary(job_candidate_id, count, abortSignal: AbortSignal) {
    const url = buildUrl(
        Routing.Api.Pro.Referrals.ACTIVITIES_SUMMARY,
        { id: job_candidate_id },
        { count }
    );

    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };

    return refetch(url, settings).then(unwrapResult);
}

// helpers...
// TODO: This may be useful for all services.
function unwrapResult(response) {
    return ErrorService.handleErrors(response)
        .then(resp => resp.json())
        .then(json => json.result);
}
